import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isCorporateOnboarding, isTokenAvailable } from "utilities/storageUtilities";
import { isHMIToken } from "utilities/utilities";
import useRolesPermissions from "hooks/useRolesPermissions";

export const ProtectedCorporateRoute = ({
    redirectPath = `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.LOGIN}`,
}: {
    redirectPath?: string;
}) => {
    const isOnboarding = isCorporateOnboarding();
    const token = isTokenAvailable();
    const location = useLocation();
    const { CORPORATE_PERMISSIONS } = useRolesPermissions();
    const pathname = location.pathname?.toLowerCase();

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    } else if (
        token &&
        isOnboarding &&
        CORPORATE_PERMISSIONS?.corporationPermissions?.canEditSettings &&
        pathname !== `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.SETUP_DASHBOARD}`
    ) {
        if (isHMIToken()) {
            return <Navigate to={redirectPath} replace />;
        }
        return (
            <Navigate
                to={`/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.SETUP_DASHBOARD}`}
                replace
            />
        );
    }
    if (isHMIToken()) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />;
};
